"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCopayCollectionEnabled = exports.isOrderPaymentComplete = exports.computeOrderPaymentBalance = exports.getPaymentReversalLabel = exports.sumNetPaymentsCents = exports.netPaymentAmountCents = exports.collectPaymentsFromClaims = exports.getClaimAmountDueCents = exports.toIntegerCents = exports.centsToDollars = exports.dollarsToCents = exports.PAYABLE_CLAIM_STATUSES = void 0;
const claim_1 = require("./claim");
/** Claim statuses that contribute to patient copay due (D-002.810). */
exports.PAYABLE_CLAIM_STATUSES = [
    claim_1.ClaimStatus.Dispensed,
    claim_1.ClaimStatus.Intended,
    claim_1.ClaimStatus.Refilled,
    claim_1.ClaimStatus.Refill,
    claim_1.ClaimStatus.RefillDelayed,
    claim_1.ClaimStatus.RefillDone
];
/**
 * UI dollars → integer cents for CardConnect / payment.amountPaid.
 * Uses Math.round so values like 1100.85 do not become 110084.999… floats.
 */
exports.dollarsToCents = (dollars) => {
    const n = Number(dollars);
    if (!Number.isFinite(n))
        return 0;
    return Math.round(n * 100);
};
/** Integer (or near-integer) cents → dollar number with 2 decimal places (ledger). */
exports.centsToDollars = (cents) => {
    const n = Number(cents);
    if (!Number.isFinite(n))
        return 0;
    return Number((n / 100).toFixed(2));
};
/** Coerce a value that should already be cents into a safe integer. */
exports.toIntegerCents = (cents) => {
    const n = Number(cents);
    if (!Number.isFinite(n))
        return 0;
    return Math.round(n);
};
/** Same due logic as payment.tsx / orders-detail / pendingPayablelist. */
exports.getClaimAmountDueCents = (claim) => {
    var _a, _b, _c;
    if (claim.responses) {
        return exports.toIntegerCents((_c = (_b = (_a = claim.copay) === null || _a === void 0 ? void 0 : _a.newPatientAmount) !== null && _b !== void 0 ? _b : claim.patientAmount) !== null && _c !== void 0 ? _c : 0);
    }
    return Math.round((claim.price || 0) * 100 * (claim.quantity || 0));
};
exports.collectPaymentsFromClaims = (claims = []) => {
    const byId = new Map();
    for (const claim of claims) {
        for (const payment of claim.payments || []) {
            if ((payment === null || payment === void 0 ? void 0 : payment.id) != null) {
                byId.set(payment.id, payment);
            }
        }
    }
    return Array.from(byId.values());
};
exports.netPaymentAmountCents = (payment) => (payment.amountPaid || 0) - (payment.refundedAmount || 0);
exports.sumNetPaymentsCents = (payments = []) => payments.reduce((sum, payment) => sum + exports.netPaymentAmountCents(payment), 0);
exports.getPaymentReversalLabel = (payment) => {
    if (!(payment.refundedAmount || 0))
        return null;
    if (payment.refundStatus === "voided")
        return "Voided";
    if (payment.refundStatus === "refunded")
        return "Refunded";
    if (payment.refundStatus === "processing")
        return "Processing";
    if (payment.refundStatus === "failed")
        return "Failed";
    return "Reversed";
};
exports.computeOrderPaymentBalance = (claims = [], payments = []) => {
    const payableClaims = claims.filter((claim) => exports.PAYABLE_CLAIM_STATUSES.includes(claim.status));
    const totalDueCents = payableClaims.reduce((total, claim) => total + exports.getClaimAmountDueCents(claim), 0);
    const totalPaidCents = payments.reduce((sum, payment) => sum + exports.netPaymentAmountCents(payment), 0);
    return {
        totalDueCents,
        totalPaidCents,
        complete: totalDueCents <= totalPaidCents
    };
};
exports.isOrderPaymentComplete = (claims = [], payments) => {
    const paymentRows = payments && payments.length > 0
        ? payments
        : exports.collectPaymentsFromClaims(claims);
    return exports.computeOrderPaymentBalance(claims, paymentRows).complete;
};
/** Site + company flags must both be enabled for copay-collection UX. */
exports.isCopayCollectionEnabled = (allowSiteCopayCollection, allowCompanyCopayCollection) => !!allowSiteCopayCollection && !!allowCompanyCopayCollection;



//////////////////
// WEBPACK FOOTER
// ./src/shared/patient-payment-balance.ts
// module id = 355
// module chunks = 0 1